import { DOMAIN_ALIASES } from 'constants/hostnames'

type Props = {
  url?: string
}

const HrefLangTags = ({ url }: Props) => {
  if (!url) return null

  const { host, pathname, search } = new URL(url)
  const environment = host.includes('sandbox') ? 'sandbox' : 'production'

  return (
    <>
      {Object.keys(DOMAIN_ALIASES[environment]).map(locale => (
        <link
          rel="alternate"
          href={`https://${DOMAIN_ALIASES[environment][locale]}${pathname}${search}`}
          hrefLang={locale}
          key={locale}
        />
      ))}
    </>
  )
}

export default HrefLangTags
